import { gql } from "@apollo/client"

const GET_ACCESS_CODE_BY_CODE = gql`
  query AccessCodes($code: String) {
    access_codes(where: { code: { _eq: $code } }) {
      id
      name
      code
      active
      opens_at
      closes_at
      max_orders
      max_participant_orders_per_period
      participant_order_period
      enterprise_client_id
      kit_selection_enabled
      auto_register_orders
      test_taker_paid
      spree_orders_aggregate {
        aggregate {
          count
        }
      }
      access_code_products(
        where: {
          enterprise_partner_product: { lens_orderable: { _eq: true } }
        }
      ) {
        id
        kits_period
        max_kits
        max_kits_per_period
        max_per_order
        enterprise_partner_product {
          id
          spree_product {
            name
          }
        }
      }
      access_code_shipping_methods {
        spree_shipping_method {
          id
        }
      }
    }
  }
`

export default GET_ACCESS_CODE_BY_CODE
